import { isBetaFeatureEnabled } from "@/components/beta-feature";
import { useStoredPreference } from "./use-stored-preference";

/**
 * 베타에서만 켤 수 있는 on/off 설정. 값은 localStorage에 남는다.
 *
 * 베타가 꺼져 있으면 저장값과 무관하게 꺼진 것으로 본다 — 베타에서 빠진 사용자의 남은
 * 저장값으로 베타 전용 요청/화면이 되살아나지 않게 한다.
 * 저장·구독은 useStoredPreference 와 같은 것을 쓴다.
 */
export const useBetaPreference = (storageKey: string) => {
  const { enabled, setEnabled } = useStoredPreference(storageKey);
  return { enabled: isBetaFeatureEnabled() && enabled, setEnabled };
};
